export default "__VITE_ASSET__Bn3z07kp__"